import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';
import $ from 'jquery';
import 'bootstrap';
import SeleccionPlanes from './SeleccionPlanes';
import '../tools/css/LimiteConsultasPruebaGratuita.css';

const ApiURL=process.env.REACT_APP_API_URL;
const LIMITE_CONSULTAS_DIARIAS_PRUEBA = 4;

/**
 * Guardián de suscripción para /agenda_profesional y /facturacion (ambas
 * cargan la app externa dentro de un iframe). Con la misma respuesta de
 * eco-prestador-get valida, en orden de prioridad:
 *
 *   1) LimiteConsultasPruebaGratuita: si la suscripción vigente es de tipo
 *      "prueba_gratuita" y hoy ya se atendieron más de
 *      LIMITE_CONSULTAS_DIARIAS_PRUEBA consultas (misma data de
 *      ListExternalConsultation que consume Consultas_programada.js), se
 *      muestra el modal "Límite diario alcanzado" (no descartable, solo se
 *      sale con "Volver").
 *   2) VerificarSuscripcionProfesional: si directamente no hay ninguna
 *      suscripción vigente (mismo chequeo que ya hacía Publicaciones.js en
 *      /inicio_profesional), se muestra el modal "Activa tu suscripción".
 *
 * Ambos casos son mutuamente excluyentes (el paso 1 requiere una suscripción
 * vigente activa), así que nunca se solapan; el orden solo determina cuál
 * se evalúa/comunica primero cuando ambos ameritarían revisión.
 */
class LimiteConsultasPruebaGratuita extends Component {

  state = {
    mostrarModalLimite: false,
    mostrarModalSinSuscripcion: false
  };

  componentDidMount(){
    this.validarSuscripcionYLimite();
  }

  validarSuscripcionYLimite(){
    const identificacion = sessionStorage.getItem('identificacion_profesional');
    console.log('[LimiteConsultasPruebaGratuita] identificacion_profesional:', identificacion);
    if (!identificacion) {
      console.log('[LimiteConsultasPruebaGratuita] sin identificacion_profesional en sessionStorage, no se valida nada.');
      return;
    }

    axios.get("https://ukvjbkxaqzltngpbrdfi.supabase.co/functions/v1/eco-prestador-get?identificacion=" + identificacion)
    .then((response) => {
      const datos = response.data;
      console.log('[LimiteConsultasPruebaGratuita] respuesta eco-prestador-get:', datos);

      // Prioridad 1: límite diario de la prueba gratuita.
      if (datos && datos.suscripcion_vigente && datos.suscripcion_vigente.tipo_compra === 'prueba_gratuita') {
        this.validarLimiteConsultasDelDia();
        return;
      }

      // Prioridad 2: sin ninguna suscripción vigente (VerificarSuscripcionProfesional).
      if (!datos || !datos.suscripcion_vigente) {
        console.log('[LimiteConsultasPruebaGratuita] sin suscripción vigente, mostrando aviso.');
        this.setState({ mostrarModalSinSuscripcion: true }, () => {
          $('#modal-sin-suscripcion-general').modal('show');
        });
        return;
      }

      console.log('[LimiteConsultasPruebaGratuita] suscripción vigente de plan pago, no se muestra ningún aviso.');
    })
    .catch((error) => console.log('[LimiteConsultasPruebaGratuita] error consultando eco-prestador-get:', error));
  }

  validarLimiteConsultasDelDia(){
    axios.get(ApiURL + "/api/Consultations/ListExternalConsultation")
    .then((respuestaConsultas) => {
      const consultas = (respuestaConsultas.data && respuestaConsultas.data.data) || [];
      const consultasHoy = consultas.filter((c) => c && c.date && moment(c.date).isSame(moment(), 'day'));
      console.log('[LimiteConsultasPruebaGratuita] total consultas:', consultas.length, '| consultas de hoy:', consultasHoy.length, '| límite:', LIMITE_CONSULTAS_DIARIAS_PRUEBA);

      if (consultasHoy.length > LIMITE_CONSULTAS_DIARIAS_PRUEBA) {
        console.log('[LimiteConsultasPruebaGratuita] límite superado, mostrando modal.');
        this.setState({ mostrarModalLimite: true }, () => {
          $('#modal-limite-prueba-gratuita').modal('show');
        });
      } else {
        console.log('[LimiteConsultasPruebaGratuita] dentro del límite, no se muestra el modal.');
      }
    })
    .catch((error) => console.log('[LimiteConsultasPruebaGratuita] error consultando ListExternalConsultation:', error));
  }

  volver = () => {
    $('#modal-limite-prueba-gratuita').modal('hide');
    window.history.back();
  };

  actualizarPlan = () => {
    $('#modal-limite-prueba-gratuita').modal('hide');
    $('#modal-comprar-plan').modal('show');
  };

  atrasDesdePlanes = () => {
    $('#modal-comprar-plan').modal('hide');
    $('#modal-limite-prueba-gratuita').modal('show');
  };

  render(){
    const { mostrarModalLimite, mostrarModalSinSuscripcion } = this.state;
    if (!mostrarModalLimite && !mostrarModalSinSuscripcion) return null;

    return (
      <React.Fragment>

      {mostrarModalLimite ? (
      <React.Fragment>

      <div className="modal fade" id="modal-limite-prueba-gratuita" data-backdrop="static" data-keyboard="false">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content limite-prueba-modal">

            <div className="modal-header limite-prueba-modal__header">
              <div className="limite-prueba-modal__icono"><i className="fas fa-hourglass-half"></i></div>
              <h4 className="modal-title limite-prueba-modal__title">¡Límite diario alcanzado!</h4>
            </div>

            <div className="modal-body limite-prueba-modal__body">
              <p>Haz superado el límite diario de atenciones autorizadas en la prueba gratuita. Podrás realizar más atenciones <b>a partir del {moment().add(1, 'day').format('DD/MM/YYYY')} a las 00:00 horas.</b></p>

              <div className="limite-prueba-modal__aviso">
                <i className="fas fa-clock"></i>
                <span>¡Actualiza tu plan ahora para atender pacientes sin límites!</span>
              </div>

              <p>Suscríbete y disfruta de los múltiples beneficios que te ofrece el Ecosistema médico 360.</p>
            </div>

            <div className="modal-footer limite-prueba-modal__footer">
              <button type="button" className="btn limite-prueba-modal__btn-volver" onClick={this.volver}>Volver</button>
              <button type="button" className="btn limite-prueba-modal__btn-plan" onClick={this.actualizarPlan}><i className="fas fa-crown"></i> Actualizar plan</button>
            </div>

          </div>
        </div>
      </div>

      <div className="modal fade" id="modal-comprar-plan" data-backdrop="static" data-keyboard="false">
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
          <div className="modal-content aviso-plan">
            <div className="modal-header aviso-plan__header">
              <h4 className="modal-title aviso-plan__title"><i className="fas fa-crown"></i> Actualiza tu plan</h4>
            </div>
            <div className="modal-body">
              <p className="aviso-plan__mensaje">Elige el plan que mejor se ajuste a tu consultorio y atiende sin el límite diario de la prueba gratuita.</p>
              <SeleccionPlanes/>
            </div>
            <div className="modal-footer aviso-plan__footer">
              <button type="button" className="btn aviso-plan__btn-atras" onClick={this.atrasDesdePlanes}>Atrás</button>
            </div>
          </div>
        </div>
      </div>

      </React.Fragment>
      ) : null}

      {mostrarModalSinSuscripcion ? (
      <div className="modal fade" id="modal-sin-suscripcion-general" data-backdrop="static">
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
          <div className="modal-content aviso-plan">
            <div className="modal-header aviso-plan__header">
              <h4 className="modal-title aviso-plan__title"><i className="fas fa-crown"></i> Activa tu suscripción</h4>
              <button type="button" className="close aviso-plan__close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <p className="aviso-plan__mensaje">Actualmente no cuentas con una suscripción activa, es posible que algunas funcionalidades sean restringidas.</p>
              <SeleccionPlanes/>
            </div>
          </div>
        </div>
      </div>
      ) : null}

      </React.Fragment>
    );
  }
}

export default LimiteConsultasPruebaGratuita;
